<div mat-dialog-title class="grid">
  <div class="column-title">
    Historial de Handovers
  </div>
  <div class="column-close">
    <button mat-button [mat-dialog-close]="false">
      <mat-icon class="material-icons-outlined">close</mat-icon>
    </button>
  </div>
  <div class="wellCommonName">{{data.wellCommonName}}</div>
  <div class="total">Total {{data.totalHandovers}} Handovers</div>
</div>
<div mat-dialog-content>
  <app-handover-history [wellId]="data.wellId" [showHeader]="false"></app-handover-history>
</div>